import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
    name: 'buildCmcUrl',
    standalone: false
})
export class BuildCmcUrlPipe implements PipeTransform {

  private coinMarketCapUrl: string = environment.COIN_MARKET_CAP_URL;
  
  transform(path: string): string {
    return `${this.coinMarketCapUrl}/${path}`;
  }
}
